import { Injectable } from '@angular/core';
import {Recommendation, RecommendationShort} from '../model/recommendation';
import {HttpClient} from '@angular/common/http';
import {RecommendationItem} from '../model/recommendation-item';
import {Observable} from 'rxjs/Observable';
import {Id} from '../model/id';

@Injectable()
export class RecommendationService {

  constructor(private httpClient: HttpClient) { }

  list(questionnaireId : string) : Observable<RecommendationItem[]> {
    return this.httpClient.get<RecommendationItem[]>("/api/questionnaire/" + questionnaireId + "/recommendation");
  }

  create(questionnaireId : string, recommendation : RecommendationShort) : Observable<Id> {
    return this.httpClient.post<Id>("/api/questionnaire/" + questionnaireId + "/recommendation", recommendation);
  }

  update(recommendationId : string, recommendation : RecommendationShort) : Observable<any> {
    return this.httpClient.put<any>("/api/recommendation/" + recommendationId, recommendation);
  }

  delete(recommendationId : string) : Observable<any> {
    return this.httpClient.delete("/api/recommendation/" + recommendationId);
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/recommendation.service.ts